

import { Component, Vue, Prop } from "vue-property-decorator"
import { Getter, Action } from "vuex-class"

import api from "@/services/api"

import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { BModal } from "bootstrap-vue"
import { UserSettings } from "@/types/userSettings"
import { User } from "@/types"
import apiUserStatus from "@/services/api_UserStatus"
import apiNoticeboard from "@/services/api_Noticeboard"

import { UserStatus } from "@/types/userStatus"
import { Noticeboard } from "@/types/noticeboard"

@Component({
	components: {
		"userSettingsModal": BModal,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class SaveNoticeboardModal extends Vue {
	private noticeboardId: string = ""
	private title: string = ""
	private description: string = ""
	private isOpen: boolean = false

	public async openForEditing (noticeboardId: string) {
		const noticeboards = await apiNoticeboard.noticeboardList()
		const noticeboard = noticeboards.find(c => c.id === noticeboardId)!
		this.title = noticeboard.title
		this.description = noticeboard.description || ""
		this.noticeboardId = noticeboardId
		this.isOpen = true
	}

	public openForAdding () {
		this.clear()
		this.isOpen = true
	}

	private async save () {
		const noticeboard: Noticeboard = {
			id: this.noticeboardId,
			title: this.title,
			description: this.description
		}
		const noticeboardId = await apiNoticeboard.noticeboardSave(noticeboard)

		this.$emit("onSaved", noticeboardId)
		this.clear()
	}

	private clear () {
		this.noticeboardId = ""
		this.title = ""
		this.description = ""
	}
}
